/* SeeMy — ajout en un clic depuis « Complétez votre rituel » (snippets/seemy-cart-upsell.liquid).
   Dans le tiroir panier : ajout sans quitter la page, puis le tiroir se met à jour.
   Sur la page panier, ou si quelque chose échoue : envoi classique du formulaire (retour au panier). */
(function () {
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-sm-upsell]')) return;

    var drawer = document.querySelector('cart-drawer');
    var main = document.querySelector('main[data-template]');
    var onCartPage = main && main.getAttribute('data-template').indexOf('cart') === 0;
    if (onCartPage || !drawer || typeof drawer.renderContents !== 'function' || !window.fetch) return;

    e.preventDefault();
    var btn = form.querySelector('button');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }

    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer,cart-icon-bubble');
    fd.append('sections_url', window.location.pathname);

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status || !res.sections) { form.submit(); return; }
        drawer.renderContents(res);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'seemy-upsell', productVariantId: res.variant_id, cartData: res });
        }
      })
      .catch(function () { form.submit(); });
  });
})();
